// quick replies for calls
export const quickReplies = [
	"Can't talk now. What's up?",
	"I'll call you right back.",
	"I'll call you later.",
	"Can't talk now. Call me later?",
	'Custom message...'
];

// error codes for failed messages in outbox in template message page
export const errorCodes = [
	{ code: 131052, label: '(131052) Media Download Error' },
	{ code: 131053, label: '(131053) Media Upload Error' },
	{ code: 131026, label: '(131026) Message Undeliverable' },
	{ code: 131008, label: '(131008) Required Parameter Is Missing' },
	{ code: 131009, label: '(131009) Parameter Value Is Not Valid' }
];

export const SUPER_ADMIN_MONTHS = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December'
];

export const SUPER_ADMIN_CHART_COLORS = {
	background: ['#e5782d', '#6eb43f', '#0058aa', '#a91e23', '#ffcc08', '#448AFF', '#EA80FC', '#69F0AE'],
	hover: ['#e5782d', '#6eb43f', '#0058aa', '#a91e23', '#ffcc08', '#448AFF', '#EA80FC', '#69F0AE']
};

export const SUPER_ADMIN_DROPPABLE_IDS = {
	MAU: 'droppable1',
	CHART: 'droppable2',
	THIRD: 'droppable3',
	TABLE: 'droppable4'
};

export const SUPER_ADMIN_CHART_OPTIONS = {
	padding: '0px',
	responsive: true,
	maintainAspectRatio: false,
	defaultFontSize: '12px',
	width: '400',
	height: '400',
	legend: { display: true }
};

export const SUPER_ADMIN_DRAG_STYLES = {
	grid: 8,
	dragBackground: '#aa0027',
	borderStyle: '2px dashed #272a36',
	minHeight: 230,
	padding: '3%'
};

export const SUPER_ADMIN_CHART_ITEM_ID = '1';
export const SUPER_ADMIN_TABLE_ITEM_ID = '2';
export const SUPER_ADMIN_MODIFIED_ID = '9898';

// menuItems for Admin Chatbot
export const menuItemsAdminChatbotAdd = [
	{ value: 'text', label: 'Text' },
	{ value: 'image', label: 'Image' },
	{ value: 'audio', label: 'Audio' },
	{ value: 'video', label: 'Video' },
	{ value: 'document', label: 'Document' },
	{ value: 'action', label: 'Action' },
	{ value: 'ic', label: 'Information Collection' },
	{ value: 'testApi', label: 'Test Api' },
	{ value: 'customApi', label: 'Custom Api' },
	{ value: 'order', label: 'Order' },
	{ value: 'location', label: 'Location' },
	{ value: 'interactive', label: 'Interactive' }
];

export const menuItemsAdminChatbotFeedback = [
	{ value: 'text', label: 'Text' },
	{ value: 'image', label: 'Image' },
	{ value: 'audio', label: 'Audio' },
	{ value: 'video', label: 'Video' },
	{ value: 'document', label: 'Document' },
	{ value: 'interactive', label: 'Interactive' }
];

//verticalOptions for profile page
export const VERTICAL_OPTIONS_PROFILE = [
	{ value: 'ALCOHOL', label: 'Alcoholic Beverages' },
	{ value: 'APPAREL', label: 'Clothing and Apparel' },
	{ value: 'AUTO', label: 'Automotive' },
	{ value: 'BEAUTY', label: 'Beauty, Spa and Salon' },
	{ value: 'EDU', label: 'Education' },
	{ value: 'ENTERTAIN', label: 'Entertainment' },
	{ value: 'EVENT_PLAN', label: 'Event Planning and Service' },
	{ value: 'FINANCE', label: 'Finance and Banking' },
	{ value: 'GOVT', label: 'Public Service' },
	{ value: 'GROCERY', label: 'Food and Grocery' },
	{ value: 'HEALTH', label: 'Medical and Health' },
	{ value: 'HOTEL', label: 'Hotel and Lodging' },
	{ value: 'NONPROFIT', label: 'Non-profit' },
	{ value: 'ONLINE_GAMBLING', label: 'Online Gambling & Gaming' },
	{ value: 'OTC_DRUGS', label: 'Over-the-Counter Drugs' },
	{ value: 'PHYSICAL_GAMBLING', label: 'Non-Online Gambling & Gaming (E.g. Brick and mortar)' },
	{ value: 'PROF_SERVICES', label: 'Professional Services' },
	{ value: 'RESTAURANT', label: 'Restaurant' },
	{ value: 'RETAIL', label: 'Shopping and Retail' },
	{ value: 'TRAVEL', label: 'Travel and Transportation' },
	{ value: 'OTHER', label: 'Other' }
];

// Email validation regex
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// URL validation regex
export const urlRegex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;

export const META_PROFILE_FIELDS = [
	{ label: 'Verified Name', key: 'verified_name' },
	{ label: 'Verification Status', key: 'code_verification_status' },
	{ label: 'Phone Number', key: 'display_phone_number' },
	{ label: 'Quality Rating', key: 'quality_rating' },
	{ label: 'Throughput Level', key: 'throughput.level' },
	{ label: 'Last Onboarded', key: 'last_onboarded_time', isDate: true },
	{ label: 'ID', key: 'id' }
];

export const INITIAL_PROFILE_STATE = {
	about: '',
	address: '',
	description: '',
	email: '',
	profile_picture_url: '',
	websites: ['', ''],
	vertical: 'AUTO',
	messaging_product: ''
};

export const SIZE_LIMIT_BYTES_PROFILE_IMAGE_UPLOAD = 10000000;
export const ALLOWED_EXTENSIONS_PROFILE_IMAGE_UPLOAD = ['jpeg', 'jpg', 'png'];

// MESSAGE STATUS FOR CUSTOMER JOURNEY TIMELINE
export const MESSAGE_STATUS = {
	2: 'enqueued',
	3: 'sent',
	4: 'delivered',
	5: 'dispatched',
	6: 'read',
	7: 'failed',
	8: 'undelivered',
	9: 'no-match-template',
	10: 'delayed',
	11: 'cancelled',
	12: 'deleted'
};

// RETRYABLE_ERROR_CODES for outbox
export const RETRYABLE_ERROR_CODES = [131052, 131053, 131042];

// COUNTRY_CODES
export const COUNTRY_CODES = [
	{ label: 'Afghanistan +93', value: '+93' },
	{ label: 'Albania +355', value: '+355' },
	{ label: 'Algeria +213', value: '+213' },
	{ label: 'Andorra +376', value: '+376' },
	{ label: 'Angola +244', value: '+244' },
	{ label: 'Antigua and Barbuda +1-268', value: '+1268' },
	{ label: 'Argentina +54', value: '+54' },
	{ label: 'Armenia +374', value: '+374' },
	{ label: 'Australia +61', value: '+61' },
	{ label: 'Austria +43', value: '+43' },
	{ label: 'Azerbaijan +994', value: '+994' },
	{ label: 'Bahamas +1-242', value: '+1242' },
	{ label: 'Bahrain +973', value: '+973' },
	{ label: 'Bangladesh +880', value: '+880' },
	{ label: 'Barbados +1-246', value: '+1246' },
	{ label: 'Belarus +375', value: '+375' },
	{ label: 'Belgium +32', value: '+32' },
	{ label: 'Belize +501', value: '+501' },
	{ label: 'Benin +229', value: '+229' },
	{ label: 'Bhutan +975', value: '+975' },
	{ label: 'Bolivia +591', value: '+591' },
	{ label: 'Bosnia and Herzegovina +387', value: '+387' },
	{ label: 'Botswana +267', value: '+267' },
	{ label: 'Brazil +55', value: '+55' },
	{ label: 'Brunei +673', value: '+673' },
	{ label: 'Bulgaria +359', value: '+359' },
	{ label: 'Burkina Faso +226', value: '+226' },
	{ label: 'Burundi +257', value: '+257' },
	{ label: 'Cambodia +855', value: '+855' },
	{ label: 'Cameroon +237', value: '+237' },
	{ label: 'Canada +1', value: '+1' },
	{ label: 'Cape Verde +238', value: '+238' },
	{ label: 'Central African Republic +236', value: '+236' },
	{ label: 'Chad +235', value: '+235' },
	{ label: 'Chile +56', value: '+56' },
	{ label: 'China +86', value: '+86' },
	{ label: 'Colombia +57', value: '+57' },
	{ label: 'Comoros +269', value: '+269' },
	{ label: 'Congo +242', value: '+242' },
	{ label: 'Congo (DRC) +243', value: '+243' },
	{ label: 'Costa Rica +506', value: '+506' },
	{ label: 'Croatia +385', value: '+385' },
	{ label: 'Cuba +53', value: '+53' },
	{ label: 'Cyprus +357', value: '+357' },
	{ label: 'Czech Republic +420', value: '+420' },
	{ label: 'Denmark +45', value: '+45' },
	{ label: 'Djibouti +253', value: '+253' },
	{ label: 'Dominica +1-767', value: '+1767' },
	{ label: 'Dominican Republic +1-809', value: '+1809' },
	{ label: 'Ecuador +593', value: '+593' },
	{ label: 'Egypt +20', value: '+20' },
	{ label: 'El Salvador +503', value: '+503' },
	{ label: 'Equatorial Guinea +240', value: '+240' },
	{ label: 'Eritrea +291', value: '+291' },
	{ label: 'Estonia +372', value: '+372' },
	{ label: 'Eswatini +268', value: '+268' },
	{ label: 'Ethiopia +251', value: '+251' },
	{ label: 'Fiji +679', value: '+679' },
	{ label: 'Finland +358', value: '+358' },
	{ label: 'France +33', value: '+33' },
	{ label: 'Gabon +241', value: '+241' },
	{ label: 'Gambia +220', value: '+220' },
	{ label: 'Georgia +995', value: '+995' },
	{ label: 'Germany +49', value: '+49' },
	{ label: 'Ghana +233', value: '+233' },
	{ label: 'Greece +30', value: '+30' },
	{ label: 'Grenada +1-473', value: '+1473' },
	{ label: 'Guatemala +502', value: '+502' },
	{ label: 'Guinea +224', value: '+224' },
	{ label: 'Guinea-Bissau +245', value: '+245' },
	{ label: 'Guyana +592', value: '+592' },
	{ label: 'Haiti +509', value: '+509' },
	{ label: 'Honduras +504', value: '+504' },
	{ label: 'Hong Kong +852', value: '+852' },
	{ label: 'Hungary +36', value: '+36' },
	{ label: 'Iceland +354', value: '+354' },
	{ label: 'India +91', value: '+91' },
	{ label: 'Indonesia +62', value: '+62' },
	{ label: 'Iran +98', value: '+98' },
	{ label: 'Iraq +964', value: '+964' },
	{ label: 'Ireland +353', value: '+353' },
	{ label: 'Italy +39', value: '+39' },
	{ label: 'Ivory Coast +225', value: '+225' },
	{ label: 'Jamaica +1-876', value: '+1876' },
	{ label: 'Japan +81', value: '+81' },
	{ label: 'Jordan +962', value: '+962' },
	{ label: 'Kazakhstan +7', value: '+7' },
	{ label: 'Kenya +254', value: '+254' },
	{ label: 'Kiribati +686', value: '+686' },
	{ label: 'Kosovo +383', value: '+383' },
	{ label: 'Kuwait +965', value: '+965' },
	{ label: 'Kyrgyzstan +996', value: '+996' },
	{ label: 'Laos +856', value: '+856' },
	{ label: 'Latvia +371', value: '+371' },
	{ label: 'Lebanon +961', value: '+961' },
	{ label: 'Lesotho +266', value: '+266' },
	{ label: 'Liberia +231', value: '+231' },
	{ label: 'Libya +218', value: '+218' },
	{ label: 'Liechtenstein +423', value: '+423' },
	{ label: 'Lithuania +370', value: '+370' },
	{ label: 'Luxembourg +352', value: '+352' },
	{ label: 'Macau +853', value: '+853' },
	{ label: 'Madagascar +261', value: '+261' },
	{ label: 'Malawi +265', value: '+265' },
	{ label: 'Malaysia +60', value: '+60' },
	{ label: 'Maldives +960', value: '+960' },
	{ label: 'Mali +223', value: '+223' },
	{ label: 'Malta +356', value: '+356' },
	{ label: 'Marshall Islands +692', value: '+692' },
	{ label: 'Mauritania +222', value: '+222' },
	{ label: 'Mauritius +230', value: '+230' },
	{ label: 'Mexico +52', value: '+52' },
	{ label: 'Micronesia +691', value: '+691' },
	{ label: 'Moldova +373', value: '+373' },
	{ label: 'Monaco +377', value: '+377' },
	{ label: 'Mongolia +976', value: '+976' },
	{ label: 'Montenegro +382', value: '+382' },
	{ label: 'Morocco +212', value: '+212' },
	{ label: 'Mozambique +258', value: '+258' },
	{ label: 'Myanmar +95', value: '+95' },
	{ label: 'Namibia +264', value: '+264' },
	{ label: 'Nauru +674', value: '+674' },
	{ label: 'Nepal +977', value: '+977' },
	{ label: 'Netherlands +31', value: '+31' },
	{ label: 'New Zealand +64', value: '+64' },
	{ label: 'Nicaragua +505', value: '+505' },
	{ label: 'Niger +227', value: '+227' },
	{ label: 'Nigeria +234', value: '+234' },
	{ label: 'North Korea +850', value: '+850' },
	{ label: 'North Macedonia +389', value: '+389' },
	{ label: 'Norway +47', value: '+47' },
	{ label: 'Oman +968', value: '+968' },
	{ label: 'Pakistan +92', value: '+92' },
	{ label: 'Palau +680', value: '+680' },
	{ label: 'Palestine +970', value: '+970' },
	{ label: 'Panama +507', value: '+507' },
	{ label: 'Papua New Guinea +675', value: '+675' },
	{ label: 'Paraguay +595', value: '+595' },
	{ label: 'Peru +51', value: '+51' },
	{ label: 'Philippines +63', value: '+63' },
	{ label: 'Poland +48', value: '+48' },
	{ label: 'Portugal +351', value: '+351' },
	{ label: 'Qatar +974', value: '+974' },
	{ label: 'Romania +40', value: '+40' },
	{ label: 'Russia +7', value: '+7' },
	{ label: 'Rwanda +250', value: '+250' },
	{ label: 'Saint Kitts and Nevis +1-869', value: '+1869' },
	{ label: 'Saint Lucia +1-758', value: '+1758' },
	{ label: 'Saint Vincent and the Grenadines +1-784', value: '+1784' },
	{ label: 'Samoa +685', value: '+685' },
	{ label: 'San Marino +378', value: '+378' },
	{ label: 'Sao Tome and Principe +239', value: '+239' },
	{ label: 'Saudi Arabia +966', value: '+966' },
	{ label: 'Senegal +221', value: '+221' },
	{ label: 'Serbia +381', value: '+381' },
	{ label: 'Seychelles +248', value: '+248' },
	{ label: 'Sierra Leone +232', value: '+232' },
	{ label: 'Singapore +65', value: '+65' },
	{ label: 'Slovakia +421', value: '+421' },
	{ label: 'Slovenia +386', value: '+386' },
	{ label: 'Solomon Islands +677', value: '+677' },
	{ label: 'Somalia +252', value: '+252' },
	{ label: 'South Africa +27', value: '+27' },
	{ label: 'South Korea +82', value: '+82' },
	{ label: 'South Sudan +211', value: '+211' },
	{ label: 'Spain +34', value: '+34' },
	{ label: 'Sri Lanka +94', value: '+94' },
	{ label: 'Sudan +249', value: '+249' },
	{ label: 'Suriname +597', value: '+597' },
	{ label: 'Sweden +46', value: '+46' },
	{ label: 'Switzerland +41', value: '+41' },
	{ label: 'Syria +963', value: '+963' },
	{ label: 'Taiwan +886', value: '+886' },
	{ label: 'Tajikistan +992', value: '+992' },
	{ label: 'Tanzania +255', value: '+255' },
	{ label: 'Thailand +66', value: '+66' },
	{ label: 'Timor-Leste +670', value: '+670' },
	{ label: 'Togo +228', value: '+228' },
	{ label: 'Tonga +676', value: '+676' },
	{ label: 'Trinidad and Tobago +1-868', value: '+1868' },
	{ label: 'Tunisia +216', value: '+216' },
	{ label: 'Turkey +90', value: '+90' },
	{ label: 'Turkmenistan +993', value: '+993' },
	{ label: 'Tuvalu +688', value: '+688' },
	{ label: 'Uganda +256', value: '+256' },
	{ label: 'Ukraine +380', value: '+380' },
	{ label: 'United Arab Emirates +971', value: '+971' },
	{ label: 'United Kingdom +44', value: '+44' },
	{ label: 'United States +1', value: '+1' },
	{ label: 'Uruguay +598', value: '+598' },
	{ label: 'Uzbekistan +998', value: '+998' },
	{ label: 'Vanuatu +678', value: '+678' },
	{ label: 'Vatican City +379', value: '+379' },
	{ label: 'Venezuela +58', value: '+58' },
	{ label: 'Vietnam +84', value: '+84' },
	{ label: 'Yemen +967', value: '+967' },
	{ label: 'Zambia +260', value: '+260' },
	{ label: 'Zimbabwe +263', value: '+263' }
];

// PREDEFINED EMAILS FOR EMAIL CONSUMTION REPORT
export const PREDEFINED_EMAILS = [
	'ammad.mukri@its.com.pk',
	'ammar@its.com.pk',
	'arshad.zaman@its.com.pk',
	'fakhir.ali@its.com.pk',
	'faheemkhan@its.com.pk',
	'fahad.k@its.com.pk',
	'rameez@its.com.pk'
];

// Constant Date Format For Overall Portal

export const globalDateFormat = 'DD-MM-YYYY hh:mm a';

// SMS Gate Way External API Config

export const smsGetwayExternalSmsApiConfig = {
	baseUrl: 'https://gatewayapi.its.com.pk/api',
	apiKey: '8A6166DE44DC44688E2C1244DCE011C9'
};
// ==================== REGISTER, CREATE ACCOUNTS PAGE FORM PROVIDER OPTIONS ==============================

export const providers = [
	{
		name: 'Whatsapp Cloud',
		value: 'whatsapp_cloud'
	},
	{
		name: 'Whatsapp Route Mobile',
		value: 'whatsapp_route_mobile'
	}
];

// ==================== CALL RECORDING / TRANSCRIPTION ANNOUNCEMENT OPTIONS ==============================

// Languages that have a localized recording / transcription announcement on the Calling API.
// The matching phrase is spoken to both participants, followed by the purpose string.
// `phrase` is the localized announcement spoken before the purpose string.
const englishAnnouncement = 'The audio of this call will be recorded for the following purpose:';

export const announcementLanguages = [
	{ name: 'English', value: 'en', phrase: englishAnnouncement },
	{ name: 'English (United States)', value: 'en_US', phrase: englishAnnouncement },
	{ name: 'English (Australia)', value: 'en_AU', phrase: englishAnnouncement },
	{ name: 'English (Canada)', value: 'en_CA', phrase: englishAnnouncement },
	{ name: 'English (United Kingdom)', value: 'en_GB', phrase: englishAnnouncement },
	{ name: 'English (India)', value: 'en_IN', phrase: englishAnnouncement },
	{ name: 'English (New Zealand)', value: 'en_NZ', phrase: englishAnnouncement },
	{ name: 'Dutch', value: 'nl', phrase: 'De audio van dit gesprek wordt voor het volgende doeleinde opgenomen:' },
	{ name: 'French', value: 'fr', phrase: 'L’audio de cet appel sera enregistré aux fins suivantes :' },
	{ name: 'German', value: 'de', phrase: 'Dieser Anruf wird zu folgenden Zwecken aufgezeichnet:' },
	{ name: 'Hindi', value: 'hi', phrase: 'इस कॉल के ऑडियो को इस उद्देश्य के लिए रिकॉर्ड किया जाएगा:' },
	{ name: 'Italian', value: 'it', phrase: 'L’audio di questa chiamata verrà registrato per il seguente scopo:' },
	{ name: 'Kannada', value: 'kn', phrase: 'ಈ ಕರೆಯ ಆಡಿಯೊವನ್ನು ಈ ಕೆಳಗಿನ ಉದ್ದೇಶಕ್ಕಾಗಿ ರೆಕಾರ್ಡ್ ಮಾಡಲಾಗುತ್ತದೆ:' },
	{
		name: 'Portuguese (Brazil)',
		value: 'pt',
		phrase: 'O áudio desta ligação será gravado para a seguinte finalidade:'
	},
	{
		name: 'Spanish (Latin America)',
		value: 'es',
		phrase: 'El audio de esta llamada se grabará con el siguiente propósito:'
	},
	{ name: 'Spanish (Spain)', value: 'es_ES', phrase: 'El audio de esta llamada se grabará con el fin siguiente:' },
	{ name: 'Telugu', value: 'te', phrase: 'ఈ కాల్ ఆడియో‌ను క్రింది అవసరం కోసం రికార్డ్ చేయడం జరుగుతుంది:' },
	{ name: 'Vietnamese', value: 'vi', phrase: 'Âm thanh của cuộc gọi này sẽ được ghi lại cho mục đích sau:' }
];

// Purpose spoken to both participants as part of the announcement. Maximum 250 characters.
export const announcementPurposes = [
	{ name: 'Quality assurance and service improvement', value: 'Quality assurance and service improvement' },
	{ name: 'Training and coaching purposes', value: 'Training and coaching purposes' },
	{ name: 'Compliance and regulatory requirements', value: 'Compliance and regulatory requirements' },
	{ name: 'Customer support and dispute resolution', value: 'Customer support and dispute resolution' },
	{ name: 'Order verification and record keeping', value: 'Order verification and record keeping' }
];

export const staticUsers = [
	{
		name: 'Faheem Khan',
		email: 'faheemkhan@its.com.pk',
		number: '923008997733'
	},
	{
		name: 'Mohammad Danish',
		email: 'danish@its.com.pk',
		number: '923153344733'
	},
	{
		name: 'Saeed Lodhi',
		email: 'saeed.lodhi@its.com.pk',
		number: '923200887206'
	},
	{
		name: 'Mirza Faheem Saeed',
		email: 'mirza.faheem@its.com.pk',
		number: '923000951112'
	},
	{
		name: 'Humna Asif',
		email: 'humna.asif@its.com.pk',
		number: '923268160023'
	},
	{
		name: 'Zamena Bawa',
		email: 'zamena@its.com.pk',
		number: '923268160034'
	},
	{
		name: 'Arsalan Khan',
		email: 'arsalan.khan@its.com.pk',
		number: '923012366926'
	},
	{
		name: 'Ahsan Ali Mughal',
		email: 'ahsanmughal@its.com.pk',
		number: '923161022272'
	},
	{
		name: 'Khizran Zehra',
		email: 'khizran.zehra@its.com.pk',
		number: '923028641805'
	},
	{
		name: 'Fahad Shah',
		email: 'fahad.shah@its.com.pk',
		number: '923212580868'
	},
	{
		name: 'Akhlaq Ahmed Shaikh',
		email: 'akhlaq.ahmed@its.com.pk',
		number: '923081533607'
	},
	{
		name: 'Arslan Ali',
		email: 'arslan.ali1396@gmail.com',
		number: '447859789573'
	},
	{
		name: 'Muhammad Umer',
		email: 'muhammad.umar@its.com.pk',
		number: '923422380923'
	},
	{
		name: 'Waqar',
		email: 'waqar.ahmed@its.com.pk',
		number: '923182015606'
	},
	{
		name: 'Noman',
		email: 'noman.ahmed@its.com.pk',
		number: '923331343944'
	},
	{
		name: 'Emaan Nadeem',
		email: 'emaan.nadeem@its.com.pk',
		number: '1'
	},
	{
		name: 'Romaisa Najam',
		email: 'romaisa.najam@its.com.pk',
		number: '1'
	},
	{
		name: 'Farhan Abid',
		email: 'farhan.abid@its.com.pk',
		number: '1'
	}
];
